import { useLocation } from "react-router-dom";
import { extractLanguageFromPath, addLanguageToPath } from "@Utils/languageCore";
import { isRegionalBlogLanguage } from "./blogLanguage";

/**
 * Returns the language-aware blog base path for the current route
 * (e.g. "/fr/blog" on French blog pages, "/blog" otherwise).
 * SSR-safe: derives from react-router location, not window.
 *
 * Uses isRegionalBlogLanguage to guard against languages that are app-supported
 * but do not have regional blog CMS collections.
 */
const useBlogBasePath = (): string => {
  const { pathname } = useLocation();
  const lang = extractLanguageFromPath(pathname);
  return isRegionalBlogLanguage(lang) ? addLanguageToPath("/blog", lang) : "/blog";
};

export default useBlogBasePath;
